module.exports = __webpack_public_path__ + "static/media/WebDev-sm_1x.fd9420ee.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/WebDev/WebDev-sm_1x.webp
// module id = 773
// module chunks = 0